import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorManagerState } from '@msc-b2c/interfaces/interfaces';

const initialState: ErrorManagerState = {
  errorManagerEnabled: false,
  errorManagerCode: '',
};

const errorManagerSlice = createSlice({
  name: 'errorManager',
  initialState,
  reducers: {
    setErrorManagerEnabled(state, action: PayloadAction<boolean>) {
      state.errorManagerEnabled = action.payload;
    },
    setErrorManagerCode(state, action: PayloadAction<string>) {
      state.errorManagerCode = action.payload;
    },
    resetErrorManager(state) {
      state.errorManagerEnabled = false;
      state.errorManagerCode = '';
    },
  },
});

export const { setErrorManagerEnabled, setErrorManagerCode, resetErrorManager } =
  errorManagerSlice.actions;
export default errorManagerSlice.reducer;
